import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import HomeIcon from "../../../../assets/icons/auth-form/home.png";
import { getOptionsFromEnums } from "../../../../shared/utility";
import { preferenceEnums } from "../../../../system/global-enums";
import { EMPTY_STRING } from "../../../../constants";

const options = getOptionsFromEnums(preferenceEnums.PROPERTIES_OWNS);
const HowManyProperties = () => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      <div className="question-heading">
        How many properties would you like to own?
      </div>
        {errors.noPropertiesLikeToOwn && (
          <div className="error">
            {errors.noPropertiesLikeToOwn.message}
          </div>
        )}
      <div className="form-fields">
        {options.map((option, index) => (
          <SurveyFormField
            name="noPropertiesLikeToOwn"
            key={index}
            variant="radio"
            label={option.label}
            value={option.value}
            endAdornment={
              <div className="position-absolute marks-adornment">
                <img src={HomeIcon} alt={EMPTY_STRING} />
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default HowManyProperties;
